/**
 * This helper class provides a way to know whether a given sample
 * is a keyframe or not.
 */
export class KeyframeHelper {

  private keyframes: Set<number> | undefined;

  constructor(
    syncSamples: number[] | undefined,
  ) {
    if (syncSamples !== undefined) {
      const keyframes = new Set<number>();
      syncSamples.forEach(n => keyframes.add(n - 1));
      this.keyframes = keyframes;
    }
  }

  isKeyframe(sampleIndex: number) {
    return this.keyframes === undefined ? true : this.keyframes.has(sampleIndex);
  }

}
